<template>
    <div>
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list" id="table-letters">
            <b-thead>
                <b-tr>
                    <!-- Rollback to original apps layout -->
                    <b-th>Title:</b-th>
                    <b-th>Date:</b-th>
                    <!-- <b-th>Recipient:</b-th> -->
                    <b-th>Reference:</b-th>
                    <b-th>Created By:</b-th>
                    <!-- <b-th>Author:</b-th> -->
                    <!-- <b-th>Added:</b-th> -->
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(doc, i) in documents" :key="i">
                    <b-td>
                        <input type="hidden" name="id" :value="doc.id" />
                        <router-link :to="`/patient/letter/${doc.encoded_id}`">
                            {{ doc.title || "Letter" }}
                        </router-link>
                    </b-td>

                    <b-td>
                        {{ _setDateDisplay(Number(doc.date)) }}
                    </b-td>

                    <!-- <b-td>
                        {{
                            doc.recipient
                                ? doc.recipient.display_name ||
                                  doc.recipient.name
                                : "-"
                        }}
                    </b-td> -->

                    <b-td>
                        <a
                            :href="CI_APPS + doc.soap.ci_url"
                            v-if="
                                doc.soap &&
                                doc.soap.id &&
                                doc.soap.ci_url &&
                                !isSoap
                            "
                        >
                            {{ doc.soap.label }}
                        </a>
                        <span v-else-if="doc.soap && doc.soap.id">
                            {{ doc.soap.label }}
                        </span>
                        <span v-else>-</span>
                    </b-td>

                    <b-td>
                        {{ doc.create_by ? doc.create_by.label : "-" }}
                    </b-td>

                    <b-td
                        class="options"
                        v-if="isLoadingPrintRecordId !== doc.id"
                    >
                        <b-dropdown
                            v-if="
                                _hasAccess('patient.letter.update') ||
                                _hasAccess('patient.letter.email') ||
                                _hasAccess('patient.letter.print') ||
                                _hasAccess('patient.letter.delete')
                            "
                            key=""
                            size="sm"
                            variant="link"
                            right
                            no-caret
                            lazy
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>
                            <b-dropdown-item
                                v-if="_hasAccess('patient.letter.edit')"
                                :to="`/patient/letter/${doc.encoded_id}`"
                            >
                                <i class="cus-page-white-edit"></i>
                                Edit Letter
                            </b-dropdown-item>

                            <b-dropdown-item
                                v-if="_hasAccess('patient.letter.email')"
                                @click="emailLetter(doc)"
                            >
                                <i class="cus-email"></i> Email Letter
                            </b-dropdown-item>

                            <b-dropdown-item
                                v-if="_hasAccess('patient.letter.print')"
                                @click="printLetter(doc.id)"
                            >
                                <i class="cus-printer"></i> Print Letter
                            </b-dropdown-item>

                            <b-dropdown-item
                                v-if="
                                    doc.lock_status === 0 &&
                                    _hasAccess('patient.letter.delete')
                                "
                                @click="promptDelete('letter', doc.id)"
                            >
                                <i class="cus-delete"></i> Delete Letter
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                    <b-td class="options" v-else>
                        <spinner />
                    </b-td>
                </b-tr>
                <b-tr v-if="documents.length === 0">
                    <b-td colspan="6">
                        <i>No records available</i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="showPagination"
            class="vet-pagination"
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="changePage"
        />

        <modal-delete-document
            ref="modalDeleteDocument"
            @on-success="afterDeleted"
        />

        <modal-email-letter ref="modalEmailLetter" />
    </div>
</template>

<script>
import PatientDocument from "@/services/patient-documents";
import Loader from "@/components/elements/loader-list";
import ModalDeleteDocument from "@/components/patient-documents/document-delete-modal.vue";
import ModalEmailLetter from "@/components/patient-documents/document-email-letter-modal.vue";
import Spinner from "@/components/elements/spinner";
import DOCUMENTS from "@/constants/documents";

export default {
    components: {
        Spinner,
        Loader,
        ModalDeleteDocument,
        ModalEmailLetter
    },
    props: {
        patientId: {
            type: String
        },
        soapId: {
            type: String
        }
    },
    data() {
        return {
            documents: [],
            isLoading: false,
            clientId: this.$store.state.client.client_id,
            isLoadingPrintRecordId: false,
            currentPage: 1,
            totalRows: 0,
            perPage: 0,
            showPagination: false,
            CI_APPS: process.env.CI_APPS
        };
    },
    computed: {
        userId() {
            return this.$route.params.id;
        },
        isSoap() {
            // by default this components is used in patient profile
            return this.$route.name === "soap";
        }
    },
    mounted() {
        this.getDocuments(1);
    },
    methods: {
        async getDocuments(page) {
            try {
                this.isLoading = true;

                const patientId = this.patientId;
                const type = "letters";

                const res = await PatientDocument.getDocuments(
                    patientId,
                    type,
                    {
                        page: page,
                        soapId: this.isSoap && this.soapId ? this.soapId : null
                    }
                );

                this.isLoading = false;

                if (res && res.message && res.message.code === 200) {
                    this.documents = res.resource.data;
                }
                // pagination
                this.currentPage = res.resource.current_page;
                this.totalRows = res.resource.total;
                this.perPage = res.resource.per_page;
                this.showPagination = res.resource.last_page > 1;
            } catch (e) {
                console.log(e);
            }
        },
        properDate(rawDate) {
            return this._toDateTime(rawDate).toFormat(this._getLuxonFormat());
        },
        promptDelete(type, documentId) {
            this.$refs.modalDeleteDocument.open({
                type: type,
                id: documentId
            });
        },
        afterDeleted() {
            if (this.isSoap) {
                this.$emit(
                    "onSuccess",
                    "tabDocuments",
                    DOCUMENTS.VIEWS.LETTERS,
                    false
                );
            }
            this.$emit("getTabCounts");
            this.getDocuments();
        },
        emailLetter(document) {
            this.$refs.modalEmailLetter.open(document);
        },
        async printLetter(documentId) {
            this.isLoadingPrintRecordId = documentId;
            const pdfPath = await PatientDocument.getPDFLetterURI(documentId);
            this.isLoadingPrintRecordId = null;

            if (pdfPath) {
                window.open(pdfPath, "_blank");
            } else {
                this._message("Error: Unable to print", "danger");
            }
        },
        changePage(nextPage) {
            this.getDocuments(nextPage);
        }
    }
};
</script>

<style scoped>
td.options {
    width: 50px;
    text-align: right;
}
.vet-pagination {
    margin-top: 50px;
}
</style>
